<template>
  <div>
    <el-tooltip
      :disabled="!gigConfigured"
      effect="light"
      :content="$t('Integrations_Gig_Configured_ToolTip')"
      placement="bottom"
    >
      <el-col :span="colSpan">
        <el-card @click.native="showIntegrationPopup">
          <el-tag
            v-if="computedIntegration.requiresApproval && requiresApproval"
            class="tag-status"
            type="warning"
            effect="plain"
          >
            {{ $t('Integrations_Gig_Text_Awaiting_Approval') }}
          </el-tag>
          <el-tag
            v-else-if="connectionsNumber > 0"
            class="tag-status"
            type="success"
            effect="plain"
          >
            {{
              $tc(
                'Integrations_Text_NumberConfiguredConnections',
                connectionsNumber,
                {
                  number: connectionsNumber
                }
              )
            }}
          </el-tag>

          <div class="card-container">
            <img
              :style="customImageStyles"
              class="card-image"
              :src="computedIntegration.image"
            />
          </div>

          <div class="card-content">
            <span class="card-title">
              <overflow-tooltip :value="$t(computedIntegration.title)" />
            </span>
            <span class="card-description">
              <overflow-tooltip :value="$t(computedIntegration.category)" />
            </span>
          </div>
        </el-card>
      </el-col>
    </el-tooltip>

    <integration-popup
      ref="IntegrationPopup"
      :integration="computedIntegration"
      :dynamic-integration-id="
        dynamicIntegration ? dynamicIntegration.id : null
      "
      :connections-number="connectionsNumber"
      @on-request-success="showIntegrationRequestedPopup"
    />

    <integration-requested-popup
      ref="IntegrationRequestedPopup"
      :integration="computedIntegration"
    />
  </div>
</template>

<script>
import IntegrationPopup from '@/modules/integrations/components/IntegrationPopup'
import IntegrationRequestedPopup from '@/modules/integrations/components/IntegrationRequestedPopup'
import OverflowTooltip from '@/common/components/form/OverflowTooltip'
import RestApi from '@/core/services/RestApi'
import { projectEndpoint } from '@/core/helpers'

export default {
  name: 'IntegrationCard',

  components: {
    IntegrationPopup,
    IntegrationRequestedPopup,
    OverflowTooltip
  },

  props: {
    integration: {
      type: Object,
      required: true
    },

    customImageStyles: {
      type: Object,
      required: false
    },

    dynamicIntegration: {
      type: Object,
      required: false
    }
  },

  data() {
    return {
      windowWidth: window.innerWidth,
      connectionsNumber: 0,
      requiresApproval: false
    }
  },

  mounted() {
    window.addEventListener('resize', () => {
      this.windowWidth = window.innerWidth
    })

    let request = {}
    if (this.dynamicIntegration) {
      request = this.fetchEndpointDynamicIntegrations
    } else {
      request = this.fetchEndpoint
    }

    RestApi(request).then(({ data }) => {
      this.connectionsNumber = Object.keys(data).length
      if (this.integration.requiresApproval) {
        this.requiresApproval = !!data.find(
          item => !!item.params.approved === false
        )
      }
    })
  },

  computed: {
    computedIntegration() {
      if (this.dynamicIntegration) {
        let copyOfIntegration = Object.assign({}, this.integration)
        copyOfIntegration.image = this.dynamicIntegration.image_url
        copyOfIntegration.title = this.dynamicIntegration.name
        copyOfIntegration.description = `${this.dynamicIntegration.name} integration`
        return copyOfIntegration
      } else {
        return this.integration
      }
    },

    fetchEndpointDynamicIntegrations() {
      return projectEndpoint({
        method: 'get',
        url: `integrations`,
        params: {
          dynamic_integration_id: this.dynamicIntegration.id
        }
      })
    },

    fetchEndpoint() {
      return projectEndpoint({
        method: 'get',
        url: `integrations`,
        params: {
          type: this.integration.type,
          is_dynamic: 0
        }
      })
    },

    colSpan() {
      return this.windowWidth <= 1600 ? 6 : 4
    },

    gigConfigured() {
      if (this.connectionsNumber > 0 && this.integration.type === 'gig') {
        return true
      }
      return false
    }
  },

  methods: {
    showIntegrationPopup() {
      this.$refs.IntegrationPopup.show()
    },

    showIntegrationRequestedPopup() {
      this.$refs.IntegrationRequestedPopup.show()
    }
  }
}
</script>

<style scoped>
>>> .el-card {
  margin-bottom: 16px;
  flex-grow: 1;
  border: 1px solid #dbdee7;
}

>>> .el-card:hover {
  box-shadow: rgba(67, 90, 111, 0.3) 0px 0px 1px,
    rgba(67, 90, 111, 0.47) 0px 8px 10px -4px;
  transform: translateY(-2px);
  cursor: pointer;
}

>>> .el-card__body {
  padding: 0;
}

.card-container {
  height: 190px;
  width: 100%;
  background: #f5f7fa;
  display: flex;
  align-items: center;
  justify-content: center;
}

.card-image {
  max-width: 90%;
  max-height: 100%;
}

.card-content {
  padding: 24px;
  display: flex;
  flex-direction: column;
}

.card-title {
  font-family: Open Sans;
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 24px;
  color: #333333;
  margin-bottom: 8px;
  white-space: nowrap;
}

.card-description {
  font-family: Open Sans;
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 18px;
  color: #808080;
}

.tag-status {
  position: absolute;
  margin-top: 10px;
  margin-left: 9px;
  font-weight: 600;
  font-size: 10px;
}
</style>



// WEBPACK FOOTER //
// src/modules/integrations/components/IntegrationCard.vue